function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var q = Object.defineProperty,
    D = Object.defineProperties;
var G = Object.getOwnPropertyDescriptors;
var v = Object.getOwnPropertySymbols;
var B = Object.prototype.hasOwnProperty,
    A = Object.prototype.propertyIsEnumerable;

var i = function i(t, n, a) {
  return n in t ? q(t, n, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : t[n] = a;
},
    d = function d(t, n) {
  for (var a in n || (n = {})) {
    B.call(n, a) && i(t, a, n[a]);
  }

  if (v) {
    var _iterator = _createForOfIteratorHelper(v(n)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var a = _step.value;
        A.call(n, a) && i(t, a, n[a]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
},
    E = function E(t, n) {
  return D(t, G(n));
};

var H = function H(t, n) {
  var a = {};

  for (var e in t) {
    B.call(t, e) && n.indexOf(e) < 0 && (a[e] = t[e]);
  }

  if (t != null && v) {
    var _iterator2 = _createForOfIteratorHelper(v(t)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var e = _step2.value;
        n.indexOf(e) < 0 && A.call(t, e) && (a[e] = t[e]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return a;
};

import c from "react";
import K from "@material-ui/core/TextField";
import M from "classnames";
import { get as h, set as Q } from "lodash";
import { InputAdornment as O } from "@material-ui/core";
import "./input.css";

var ae = function ae(U) {
  var C = U,
      t = C.name,
      n = C.id,
      a = C.className,
      e = C.formikProps,
      g = C.prefix,
      I = C.suffix,
      b = C.label,
      _C$labelPlacement = C.labelPlacement,
      S = _C$labelPlacement === void 0 ? "inset" : _C$labelPlacement,
      _C$variant = C.variant,
      w = _C$variant === void 0 ? "outlined" : _C$variant,
      V = C.inputConfig,
      l = H(C, ["name", "id", "className", "formikProps", "prefix", "suffix", "label", "labelPlacement", "variant", "inputConfig"]);
  var L, N;

  var u = d(d({
    labelPlacement: S
  }, (L = e == null ? void 0 : e.status) == null ? void 0 : L.formConfig), V),
      W = e ? h(e == null ? void 0 : e.values, t) : l.value,
      x = (e == null ? void 0 : e.errors) && t && h(e.touched, t) ? h(e.errors, t) : "",
      T = ((N = e == null ? void 0 : e.status) == null ? void 0 : N.serverErrors) && t && h(e.status.serverErrors, t) ? h(e.status.serverErrors, t) : "",
      _ = !!x || !!T || l.error,
      j = x || T || l.helperText,
      z = d({
    startAdornment: g ? c.createElement(O, {
      position: "start"
    }, g) : !1,
    endAdornment: I ? c.createElement(O, {
      position: "end"
    }, I) : !1
  }, l.InputProps),
      J = function J(s) {
    var y;
    (e == null ? void 0 : e.setStatus) && ((y = e == null ? void 0 : e.status) == null ? void 0 : y.serverErrors) && e.setStatus(E(d({}, e == null ? void 0 : e.status), {
      serverErrors: d({}, Q(e.status.serverErrors, t, ""))
    })), (e == null ? void 0 : e.handleChange) && e.handleChange(s), typeof l.onChange == "function" && l.onChange(s);
  },
      $ = function $(s) {
    (e == null ? void 0 : e.handleBlur) && e.handleBlur(s), typeof l.onBlur == "function" && l.onBlur(s);
  },
      F = b && u.labelPlacement === "above";

  return c.createElement("div", {
    className: M("lc-input-wrapper", {
      "lc-input-label-above": F,
      "lc-input-border-white": u.inputBorderWhite
    })
  }, F && c.createElement("label", {
    className: "lc-input-label",
    htmlFor: n || t
  }, b), c.createElement(K, E(d({
    name: u.safeName ? "['".concat(t, "']") : t,
    id: n || t,
    label: u.labelPlacement === "inset" ? b : !1,
    size: "small"
  }, l), {
    InputProps: z,
    error: _,
    helperText: j,
    className: M(a, "lc-input"),
    value: W,
    onChange: J,
    onBlur: $,
    variant: w,
    InputLabelProps: d({
      shrink: u.shrinkLabel
    }, l.InputLabelProps)
  })), (u == null ? void 0 : u.safeName) && c.createElement("input", {
    type: "hidden",
    name: t,
    defaultValue: typeof (e == null ? void 0 : e.values[t]) == "object" ? JSON.stringify(e == null ? void 0 : e.values[t]) : e == null ? void 0 : e.values[t]
  }));
};

export { ae as InputBase };